import { TIMETABLE_OPEN, TIMETABLE_ERROR, TIMETABLE_CLOSE } from './types';

export const setTimeTableOpen = () => async (dispatch) => {
  try {
    dispatch({
      type: TIMETABLE_OPEN,
      payload: { status: 'open' },
    });
  } catch (err) {
    dispatch({
      type: TIMETABLE_ERROR,
      payload: { msg: err, status: 500 },
    });
  }
};

export const setTimeTableClose = () => async (dispatch) => {
  try {
    dispatch({
      type: TIMETABLE_CLOSE,
      payload: { status: 'closed' },
    });
  } catch (err) {
    dispatch({
      type: TIMETABLE_ERROR,
      payload: { msg: err, status: 500 },
    });
  }
};
